import start from 'app/xEcoApm/event/measurement/start'

/**
 * If the `autoMeasured` flag is not set, it sets it and calls {@link start}.
 */
const startMeasurement = (obj: Gaia.AppModule.Spec) => async (...args: unknown[]) => {
  const actionState = obj[G.STATE][G.ACTION][G.STATE]

  if (!actionState.autoMeasured) {
    actionState.autoMeasured = true

    await start(obj, null, null)
  }

  return args
}

export default startMeasurement
